import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AdUnitAutocompleteComponent } from './ad-unit-autocomplete.component';
import { User } from '../domain/users/user.model';
import { UsersService } from '../services/users.service';
import { UserEmailAutocompleteComponent } from './user-email-autocomplete.component';

@Component({
  selector: 'cm-user-email-autocomplete-chips',
  template: `
    <cm-user-email-autocomplete #ac
                                [filterRoles]="filterRoles"
                                (userListAcquired)="listAcquired($event)"
                                (itemSelected)="onItemSelected($event)"></cm-user-email-autocomplete>
    <mat-chip-list #chipList>
      <mat-basic-chip *ngFor="let item of items"
                      [removable]="true"
                      (removed)="remove(item)">
        {{item.email}}
        <i class="fas fa-times-circle text-danger hand" matChipRemove></i>
      </mat-basic-chip>
    </mat-chip-list>
  `,
})
export class UserEmailAutocompleteChipsComponent implements OnInit {

  @ViewChild(UserEmailAutocompleteComponent, {static: true}) ac: UserEmailAutocompleteComponent;

  @Input()
  public placeholder: string;

  @Input()
  public userEmails: string[];

  @Input()
  filterRoles: string[];

  @Output()
  userSelectionChange = new EventEmitter<User[]>();

  items: User[] = [];

  constructor(private service: UsersService) {
  }

  ngOnInit(): void {
    if (this.userEmails && this.userEmails.length) {
      this.service.getUsers().subscribe(users => {
        users.forEach(au => {
          if (this.userEmails.includes(au.email)) {
            this.onItemSelected(au);
          }
        });
      });
    }
  }

  onItemSelected($event: User) {
    if ($event) {
      this.items.push($event);
      this.userSelectionChange.emit(this.items);
      this.ac.resetInput();
    }
  }

  remove(adUnit: User) {
    this.items.splice(this.items.indexOf(adUnit), 1);
    this.userSelectionChange.emit(this.items);
  }

  listAcquired(users: User[]) {
    if (this.userEmails) {
      users.forEach(au => {
        if (this.userEmails.includes(au.email)) {
          this.onItemSelected(au);
        }
      });
    }
  }

}
